export const UsageController = {
    index(): void {},
};
